import { render, staticRenderFns } from "./detailed_explanation.vue?vue&type=template&id=401188d6&scoped=true"
import script from "./detailed_explanation.vue?vue&type=script&lang=js"
export * from "./detailed_explanation.vue?vue&type=script&lang=js"
import style0 from "./detailed_explanation.vue?vue&type=style&index=0&id=401188d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401188d6",
  null
  
)

export default component.exports